import React from 'react';

import { useIntl } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import InlineEdit from '@atlaskit/inline-edit';
import Textfield from '@atlaskit/textfield';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import { Flex } from '@atlassian/eoc-flex';
import { Skeleton } from '@atlassian/eoc-skeleton';

import { Container } from '../../../../../common/ui/side-container/styled';
import { usePartialUpdateScheduleService } from '../../../../../controllers/list';
import { useSchedule, useTimelineLoading } from '../../../../../controllers/schedule-store/helpers';
import { isEmpty } from '../../../../../utils/validators';

import { messages } from './messages';
import { RotationList } from './rotation-list';
import { DescriptionReadView, DescriptionWrapper } from './styled';

const ListRotation = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const intlApi = useIntl();
	const [{ id: scheduleId, description }] = useSchedule();

	const { partialUpdate: updateDescription, isLoading: isDescriptionLoading } =
		usePartialUpdateScheduleService(scheduleId, 'description');

	const [{ isInitialLoading }] = useTimelineLoading();

	// NOTE: Maybe we could recreate <SkeletonContainer skeleton children isLoading /> for logics like following
	return (
		<Container>
			{isInitialLoading ? (
				<Flex flexDirection="column" rowGap={2}>
					<Skeleton height={3} width={20} />
					<Skeleton height={3} width={15} />
				</Flex>
			) : (
				<>
					<DescriptionWrapper>
						<InlineEdit
							defaultValue={description}
							editView={({ errorMessage, ...fieldProps }) => (
								<Textfield
									{...fieldProps}
									autoComplete="off"
									isCompact
									isDisabled={isDescriptionLoading}
									aria-label={intlApi.formatMessage(messages.editScheduleDescription)}
								/>
							)}
							readView={() => (
								<DescriptionReadView
									isEmpty={isEmpty(description)}
									isLoading={isDescriptionLoading}
								>
									{description || intlApi.formatMessage(messages.emptyDescriptionInfoTitle)}
								</DescriptionReadView>
							)}
							// TODO: consider adding validation for max length
							onConfirm={async (value?: string) => {
								if (value !== description) {
									const event = createAnalyticsEvent({});
									updateDescription(value ?? '', {
										onSuccess: () => {
											fireTrackAnalytics(event, 'descriptionUpdate succeeded');
										},
										onError: () => {
											fireTrackAnalytics(event, 'descriptionUpdate failed');
										},
									});
								}
							}}
							keepEditViewOpenOnBlur
							readViewFitContainerWidth
							editButtonLabel={intlApi.formatMessage(messages.editScheduleDescription)}
						/>
					</DescriptionWrapper>

					<RotationList />
				</>
			)}
		</Container>
	);
};

export { ListRotation };
